import {CallJs} from "../../lib/types"

import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {AjaxRequest} from "../../lib/ajax";
import {Currency, renderCurrencyName} from "../../lib/credit-card";
import {createStore, applyMiddleware} from "redux";
import {connect, Store} from "react-redux"
import {Dispatch} from "redux";
import thunkMiddleware from "redux-thunk";
import {Payer, StoredPayerDetails} from "../../orders2/payment-details-widget"

type AuthorisedDetails = {
	revokePath: string,
	currency: Currency,
	payerDetails: StoredPayerDetails,
	owner: string,
	date: string
}

type ViewParams = {
	details: AuthorisedDetails[]
	multicurrency: boolean
	obscure: boolean
}
type UpdateParams = {
	revoke: (path: string) => void
}

const post = (path: string) => {
	return new AjaxRequest(path).runPost<{details: AuthorisedDetails[], errors: string[]}>('application/x-www-form-urlencoded')
}

const AutorenewalDetails = (params: {details: AuthorisedDetails, multicurrency: boolean, revoke: (path: string) => void}) => <div>
	Autorenewed memberships {params.multicurrency && `using ${renderCurrencyName(params.details.currency)}`} will be paid with:
	<Payer details={params.details.payerDetails}/>
	<p>Created {params.details.date} by {params.details.owner}</p>
	<button onClick={() => params.revoke(params.details.revokePath)}>Opt Out</button>
</div>


type Action = UpdateStateAction | StartAction | AbortAction
type UpdateStateAction = {type: 'update state'; state: AuthorisedDetails[]}
type StartAction = {type: 'start'}
type AbortAction = {type: 'abort'}

type State = {
	loading: boolean
	details: AuthorisedDetails[]
}

const reducer = (state: State = {loading: false, details: []}, action: Action): State => {
	if (!action)
		return state
	switch (action.type) {
		case 'update state':
			return {loading: false, details: action.state}
		case 'start':
			return {...state, loading: true}
		case 'abort':
			return {...state, loading: false}
	}
	return state;
}

const AutorenewalDetailsView = (params: ViewParams & UpdateParams) =>
	<div style={params.obscure ? {opacity: 0.5}: undefined}>
		{params.details.map(d => <AutorenewalDetails revoke={params.revoke} key={d.revokePath} multicurrency={params.multicurrency} details={d}/>)}
		<p>To opt {!!params.details.length && "back "}in for future renewals, manually renew memberships and save credit card details during the process.</p>
	</div>

const stateMap = (state: State, ownProps: {multicurrency: boolean, store: Store<State>}): ViewParams => ({
	details: state.details,
	multicurrency: ownProps.multicurrency,
	obscure: state.loading
})

const dispatchMap = (dispatch: Dispatch<State>): UpdateParams => {
	const revoke = (path: string) => (dispatch: Dispatch<State>) => {
		dispatch({type: 'start'})
		post(path).then((result) => {
			if(result.errors.length) {
				alert(result.errors.join("\n"))
			}
			const action = {type: 'update state', state: result.details}
			dispatch(action)
		}, (e) => {
			if(e.statusNumber == 403) {
				alert('You do not have permission at this time to revoke payment details. Make sure you are logged in. If it still fails, please contact us.')
			} else {
				alert('An error has occurred trying to revoke the details. Please reload the window and try again.')
			}
			dispatch({type: 'abort'})
		})
	}
	return {
		revoke: (path) => dispatch(revoke(path))
	}
}

type AutorenewalDetailsCallJsParams = {
	details: AuthorisedDetails[]
	multicurrency: boolean
}

export const AutorenewalDetailsCallJs: CallJs<AutorenewalDetailsCallJsParams> = (replace, params) => {
	const div = document.createElement('div')
	replace(div)

	const store = createStore(reducer, {details: params.details, loading: false}, applyMiddleware(thunkMiddleware))
	const App = connect(stateMap, dispatchMap)(AutorenewalDetailsView)

	ReactDOM.render(<App multicurrency={params.multicurrency} store={store} />, div)
}



// WEBPACK FOOTER //
// ./src/membership3/my-memberships/autorenewal-details.tsx